import { useCallback, useState, useContext, useEffect } from "react";
import {
  getOrganizationLeaves,
  deleteOrganizationLeaves,
  addOrganizationLeaves,
} from "../ApplyLeave/leaveService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";

const OrgLeaveSetting = () => {
  const [columns, setColumns] = useState([
    "Leave Type",
    "Description",
    "Frequency",
    "Credit Count",
    "Expiry Frequency",
    "Expiry Count",
    "Accumulation Limit",
    "Advance Leave Window",
    "Past Leave Window",
    "Advance Notice",
  ]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgLeaveList, setOrgLeaveList] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [file, setFile] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgLeaveId, setOrgLeaveId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    GetOrgLeaves();
  }, []);

  const validateOrgLeave = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-LeaveTypes`] =
      !data.LeaveTypes || data.LeaveTypes.trim() === ""
        ? "Leavetype is required"
        : undefined;
    newErrors[`${index}-Description`] =
      !data.Description || data.Description.trim() === ""
        ? "Description is required"
        : undefined;
    newErrors[`${index}-Frequency`] =
      !data.Frequency || data.Frequency.trim() === ""
        ? "Frequency is required"
        : undefined;
    newErrors[`${index}-CreditCount`] =
      data.CreditCount === "" || data.CreditCount < 0
        ? "CreditCount is required"
        : undefined;
    newErrors[`${index}-ExpiryFrequency`] =
      !data.ExpiryFrequency || data.ExpiryFrequency.trim() === ""
        ? "ExpiryFrequency is required"
        : undefined;
    newErrors[`${index}-ExpiryCount`] =
      data.ExpiryCount < 0 || data.ExpiryCount === ""
        ? "ExpiryCount is required"
        : undefined;
    newErrors[`${index}-AccumulationLimit`] =
      data.AccumulationLimit < 0 || data.AccumulationLimit === ""
        ? "AccumulationLimit is required"
        : undefined;
    newErrors[`${index}-AdvanceLeaveWindow`] =
      data.AdvanceLeaveWindow < 0 || data.AdvanceLeaveWindow === ""
        ? "AdvanceLeaveWindow is required"
        : undefined;
    newErrors[`${index}-PastLeaveWindow`] =
      data.PastLeaveWindow < 0 || data.PastLeaveWindow === ""
        ? "PastLeaveWindow is required"
        : undefined;
    newErrors[`${index}-AdvanceNotice`] =
      data.AdvanceNotice < 0 || data.AdvanceNotice === ""
        ? "AdvanceNotice is required"
        : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgLeaves() {
    setIsloading(true);
    let body = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let response = await getOrganizationLeaves(body);
      setOrgLeaveList(response?.Data || []);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgLeaveList((prevList) => {
      const newIndex = prevList.length;
      setEditIndex(newIndex);
      return [
        ...prevList,
        {
          LeaveTypes: "",
          Description: "",
          Frequency: "",
          CreditCount: "",
          ExpiryFrequency: "",
          ExpiryCount: "",
          AccumulationLimit: "",
          AdvanceLeaveWindow: "",
          PastLeaveWindow: "",
          AdvanceNotice: "",
        },
      ];
    });
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const [data, setData] = useState({
    LeaveTypes: "",
    Description: "",
    Frequency: "",
    CreditCount: "",
    ExpiryFrequency: "",
    ExpiryCount: "",
    AccumulationLimit: "",
    AdvanceLeaveWindow: "",
    PastLeaveWindow: "",
    AdvanceNotice: "",
  });
  const handleChange = (rowIdx, colName) => (e) => {
    const value = e.target.value;
    setOrgLeaveList((prev) =>
      prev.map((item, idx) =>
        idx === rowIdx ? { ...item, [colName]: value } : item
      )
    );
    validateOrgLeave({ ...orgLeaveList[rowIdx], [colName]: value }, rowIdx);
  };

  const handleFileChange = useCallback(async (event, index) => {
    const selectedFile = event.target.files;
    setFile({ files: selectedFile, index });
  }, []);

  const cancelLeave = () => {
    GetOrgLeaves();
    setOrgLeaveList((prevList) => {
      setEditIndex(null);
      const len = prevList.length;
      if (len === 0) return prevList;
      const lastItem = prevList[len - 1];
      const isEmpty =
        lastItem &&
        !lastItem.LeaveTypes &&
        !lastItem.Description &&
        !lastItem.Frequency &&
        !lastItem.CreditCount &&
        !lastItem.ExpiryFrequency &&
        !lastItem.ExpiryCount &&
        !lastItem.AccumulationLimit &&
        !lastItem.AdvanceLeaveWindow &&
        !lastItem.PastLeaveWindow &&
        !lastItem.AdvanceNotice;

      if (isEmpty) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  };

  async function addOrgLeave(index, data) {
    const body = {
      Id: data?.Id || 0,
      OrgId: userDetails.OrgId,
      LeaveTypeId: data?.LeaveTypeId || 0,
      LeaveType: data.LeaveTypes,
      Desc: data.Description,
      Frequency: data.Frequency,
      CreditCount: parseInt(data.CreditCount, 10),
      ExpiryFrequency: data.ExpiryFrequency,
      ExpiryCount: parseInt(data.ExpiryCount, 10),
      AccumulationLimit: parseInt(data.AccumulationLimit, 10),
      AdvanceLeaveWindow: parseInt(data.AdvanceLeaveWindow, 10),
      PastLeaveWindow: parseInt(data.PastLeaveWindow, 10),
      AdvanceNotice: parseInt(data.AdvanceNotice, 10),
    };
    setIsloading(true); // good practice
    try {
      await addOrganizationLeaves(body);
      alert(orgLeaveId ? "Org Leave Updated" : "Org Leave Added");
      await GetOrgLeaves();
      setEditIndex(null);
      setErrors({});
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleLeavelstDelete = (Id) => {
    setOrgLeaveId(Id);
  };

  async function DeleteOrgLeave() {
    setIsloading(true);
    if (orgLeaveId) {
      let body = {
        Id: orgLeaveId,
      };
      try {
        let orgLeaveDeleteList = await deleteOrganizationLeaves(body);
        if (orgLeaveDeleteList) {
          setIsloading(false);
          GetOrgLeaves();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  let SearchValue = "";
  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgLeaveList.filter((orgleaves) =>
        orgleaves.LeaveTypes?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgLeaveList(filteredList);
      } else {
        GetOrgLeaves();
      }
    }, 800),
    [orgLeaveList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>Leave Types ({orgLeaveList?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Leave
              </button>
            )}
          </div>
        </div>
        <div className="col-md-12 column">
          <div className="table-responsive">
            <table className="table table-bordered table-hover" id="tab_logic">
              <thead>
                <tr>
                  {columns.map((colName, colIdx) => (
                    <th key={colIdx} className="text-left">
                      {colName}
                    </th>
                  ))}
                  <th className="text-left" style={{ width: "100px" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {orgLeaveList.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            value={row.LeaveTypes}
                            onChange={handleChange(index, "LeaveTypes")}
                            placeholder=" leave type "
                            className={`form-control ${
                              errors[`${index}-LeaveTypes`] ? "is-invalid" : ""
                            }`}
                          />
                          {errors[`${index}-LeaveTypes`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-LeaveTypes`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.LeaveTypes}</span>
                      )}
                    </td>
                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            value={row.Description}
                            onChange={handleChange(index, "Description")}
                            placeholder="Desc"
                            className={`form-control ${
                              errors[`${index}-Description`] ? "is-invalid" : ""
                            }`}
                          />
                          {errors[`${index}-Description`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-Description`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.Description}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            value={row.Frequency}
                            onChange={handleChange(index, "Frequency")}
                            placeholder="Frequency"
                            className={`form-control ${
                              errors[`${index}-Frequency`] ? "is-invalid" : ""
                            }`}
                          />
                          {errors[`${index}-Frequency`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-Frequency`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.Frequency}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.CreditCount}
                            onChange={handleChange(index, "CreditCount")}
                            placeholder="Credit Count"
                            className={`form-control ${
                              errors[`${index}-CreditCount`] ? "is-invalid" : ""
                            }`}
                          />
                          {errors[`${index}-CreditCount`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-CreditCount`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.CreditCount}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            value={row.ExpiryFrequency}
                            placeholder="Expiry Frequency"
                            onChange={handleChange(index, "ExpiryFrequency")}
                            className={`form-control ${
                              errors[`${index}-ExpiryFrequency`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          {errors[`${index}-ExpiryFrequency`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-ExpiryFrequency`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.ExpiryFrequency}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.ExpiryCount}
                            placeholder="Expiry Count"
                            onChange={handleChange(index, "ExpiryCount")}
                            className={`form-control ${
                              errors[`${index}-ExpiryCount`] ? "is-invalid" : ""
                            }`}
                          />
                          {errors[`${index}-ExpiryCount`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-ExpiryCount`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.ExpiryCount}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.AccumulationLimit}
                            placeholder="Accumulation limit"
                            onChange={handleChange(index, "AccumulationLimit")}
                            className={`form-control ${
                              errors[`${index}-AccumulationLimit`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          {errors[`${index}-AccumulationLimit`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-AccumulationLimit`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.AccumulationLimit}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.AdvanceLeaveWindow}
                            placeholder="Advance Leave Window"
                            onChange={handleChange(index, "AdvanceLeaveWindow")}
                            className={`form-control ${
                              errors[`${index}-AdvanceLeaveWindow`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          {errors[`${index}-AdvanceLeaveWindow`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-AdvanceLeaveWindow`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.AdvanceLeaveWindow}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.PastLeaveWindow}
                            onChange={handleChange(index, "PastLeaveWindow")}
                            placeholder="Past Leave Window"
                            className={`form-control ${
                              errors[`${index}-PastLeaveWindow`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          {errors[`${index}-PastLeaveWindow`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-PastLeaveWindow`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.PastLeaveWindow}</span>
                      )}
                    </td>

                    <td>
                      {editIndex === index ? (
                        <>
                          <input
                            type="number"
                            value={row.AdvanceNotice}
                            placeholder="Advance Notice"
                            onChange={handleChange(index, "AdvanceNotice")}
                            className={`form-control ${
                              errors[`${index}-AdvanceNotice`]
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          {errors[`${index}-AdvanceNotice`] && (
                            <div className="invalid-feedback">
                              {errors[`${index}-AdvanceNotice`]}
                            </div>
                          )}
                        </>
                      ) : (
                        <span>{row.AdvanceNotice}</span>
                      )}
                    </td>

                    <td className="d-flex">
                      {editIndex === index ? (
                        <>
                          <button className="editactions me-2">
                            <img
                              src="/images/org-img/profile/close.png"
                              title="Cancel"
                              className="editactions me-2"
                              onClick={() => {
                                cancelLeave();
                                setEditIndex(null);
                              }}
                            />
                          </button>
                          <button className="editactions ">
                            <img
                              src="/images/org-img/profile/check.png"
                              title="Confirm"
                              className="editactions"
                              style={{ width: "17px" }}
                              onClick={() => {
                                if (validateOrgLeave(row, index)) {
                                  addOrgLeave(index, row);
                                  setEditIndex(null);
                                }
                              }}
                            />
                          </button>
                        </>
                      ) : (
                        <>
                          <button className="editactions me-2">
                            <img
                              src="/images/tickets/edit-ico.svg"
                              title="Edit"
                              className="editactions me-2"
                              onClick={() => handleEditClick(index)}
                              style={{
                                cursor:
                                  editIndex !== null
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: editIndex !== null ? 0.5 : 1,
                              }}
                              disabled={editIndex !== null}
                            />
                          </button>
                          <button className="editactions ">
                            <img
                              src="/images/tickets/delete.svg"
                              title="Delete"
                              className="editactions"
                              onClick={() => handleLeavelstDelete(row.Id)}
                              data-bs-toggle="modal"
                              data-bs-target="#delete-org-leave"
                            />
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal fade " id="delete-org-leave">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>Do you really want to delete this leave?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgLeave()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgLeaveSetting;
